import { useState, useEffect } from 'react'
import { decodeStorage } from 'functions/storageBase64'
import { requestPayment } from 'functions/requestPayment'
import { cybs_dfprofiler } from 'functions/deviceFingerprint'
import { updateCardT1 } from 'services/T1Pagos'
import { postPayPlanCards } from 'services/PagoTajetaSears'
import { MERCHANT_ID, STAGE_DIRNAME } from 'constants/general'

export function usePayCard(){

    const [ successPay, setSuccessPay ] = useState(null)
    const [ errorPay, setErrorPay ] = useState(null)
    const [ datosPago, setDatosPago ] = useState()
    const payCardRelation = decodeStorage('payCardRelation')
    let environment = ''

    if(STAGE_DIRNAME != 'dev'){
        environment = "live"
    }

    const dataPayment = (value) => {
        setDatosPago(value)
    }
    
    // updateCard
    const [ responseT1, setResponseT1 ] = useState()
    useEffect(()=>{
        if(datosPago){
            if(!datosPago.addCard){
                //console.log('datosPago: ',datosPago)
                updateCardT1({dataRaw: {cvv2: datosPago?.cvv}, idCard: datosPago?.idCard })
                .then(setResponseT1)
            }
            else{
                setResponseT1(datosPago?.addCard)
                setDataCardT1(true)
            }
        }
    },[datosPago])

    //- Trae datos de la tarjeta T1
    const [dataCardT1, setDataCardT1] = useState(false)
    const [dataSingleCard, setdataSingleCard] = useState()
    useEffect(()=>{
        if(responseT1?.statusCode === 200){
            setdataSingleCard( requestPayment(responseT1?.data?.data, payCardRelation, cybs_dfprofiler(MERCHANT_ID, environment)) )
            setDataCardT1(true)
        }else if(responseT1?.statusCode === 401){
            setDataCardT1(false)
        }
        else if(responseT1?.statusCode >= 404){
            setDataCardT1(false)
        }
        else if(responseT1?.statusCode >= 500){
            setDataCardT1(false)
            setErrorPay(responseT1?.status?.error?.message)
        }
    },[responseT1])
    
    //- Va al servicio de pago con los datos del plan
    const [responseServicePay, setResponseServicePay] = useState(false)
    useEffect(()=>{
        if(dataCardT1 && dataSingleCard){
            postPayPlanCards(dataSingleCard)
            .then(setResponseServicePay)
        }
    },[dataCardT1, dataSingleCard])
    
    
    // Regresa la respuesta si es success o error en el pago
    useEffect(()=>{
        if(responseServicePay){
            if(responseServicePay.statusCode === 200){
                if(responseServicePay?.data?.data?.status === true){
                    setSuccessPay(responseServicePay?.data?.data?.authorization_id)
                }else if(responseServicePay?.data?.data?.status === false){
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }else{
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }
            }
            else if(responseServicePay.statusCode >= 400 && responseServicePay.statusCode <= 499){
                if(typeof(responseServicePay?.data) === 'string'){
                    let resp = JSON.parse(responseServicePay?.data)
                    setErrorPay({codMen: 31, message: resp?.data?.message})
                }else{
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }
            }
            else if(responseServicePay.statusCode >= 500){
                if(typeof(responseServicePay?.data) === 'string'){
                    let resp = JSON.parse(responseServicePay?.data)
                    setErrorPay({codMen: 31, message: resp?.data?.message})
                }else{
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }
            }
        }
    },[responseServicePay])


    return{
        successPay,
        errorPay,
        dataPayment
    }
}